"use strict";

const updateToggleAllButton = (button, items) => {
  const allOpen = items.every(
    ({ trigger }) => trigger.getAttribute("aria-expanded") === "true"
  );
  const label = allOpen ? button.dataset.closeLabel : button.dataset.openLabel;

  button.setAttribute("aria-expanded", String(allOpen));
  button.setAttribute("aria-label", label);
  const labelElement = button.querySelector(
    "[data-legacy-accordion-toggle-label]"
  );

  if (labelElement) {
    labelElement.textContent = label;
  } else {
    button.textContent = label;
  }
};

const setItemOpen = ({ trigger, panel }, open) => {
  trigger.setAttribute("aria-expanded", String(open));
  panel.toggleAttribute("hidden", !open);
};

const initializeLegacyAccordion = (root) => {
  if (root.dataset.legacyAccordionInitialized === "true") {
    return;
  }

  const items = Array.from(
    root.querySelectorAll("[data-legacy-accordion-item]")
  )
    .map((item) => ({
      trigger: item.querySelector("[data-legacy-accordion-trigger]"),
      panel: item.querySelector("[data-legacy-accordion-panel]"),
    }))
    .filter(({ trigger, panel }) => trigger && panel);

  if (items.length === 0) {
    return;
  }

  const toggleAllButton = root.querySelector(
    "[data-legacy-accordion-toggle-all]"
  );

  items.forEach((item) => {
    item.trigger.addEventListener("click", () => {
      const isOpen = item.trigger.getAttribute("aria-expanded") === "true";
      setItemOpen(item, !isOpen);

      if (toggleAllButton) {
        updateToggleAllButton(toggleAllButton, items);
      }
    });
  });

  if (toggleAllButton) {
    toggleAllButton.addEventListener("click", () => {
      const allOpen = items.every(
        ({ trigger }) => trigger.getAttribute("aria-expanded") === "true"
      );
      items.forEach((item) => setItemOpen(item, !allOpen));
      updateToggleAllButton(toggleAllButton, items);
    });

    updateToggleAllButton(toggleAllButton, items);
  }

  root.dataset.legacyAccordionInitialized = "true";
};

export const initLegacyAccordions = (container) => {
  const scope = container || document;
  const roots =
    scope.matches && scope.matches("[data-legacy-accordion]")
      ? [scope]
      : Array.from(scope.querySelectorAll("[data-legacy-accordion]"));

  roots.forEach(initializeLegacyAccordion);
};

if (typeof document !== "undefined") {
  initLegacyAccordions(document);
}
